angular.module("ainapp")
    .controller("BuildingSummaryController", ["app.config", "$scope", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Building Summary";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.basePath = config.basePath;

                $scope.filter = {
                    FromDate: null,
                    ToDate: null,
                    Pagenation: 0,
                    IsFilter: false,
                    Keyword: null
                }
                $scope.Load = true;
                $scope.Flats = [];
                $scope.FlatsArray = [];
                $scope.Buildings = [];
                MainService.BuildingsInSummary($scope.filter).then(function (res) {
                    $scope.Buildings = res.data;
                    $scope.Load = false;
                })

                $scope.ViewVal = 0;
                $scope.SelectedBuilding = {};
            }
            $scope.Init();

            $scope.MoreDetails = function (data) {
                $scope.SelectedBuilding = data;
                $scope.Load = true;
                MainService.FlatsByBuildingId(data.Id).then(function (res) {
                    $scope.Flats = res.data;
                    $scope.ViewVal = 1;
                    $scope.FlatsArray = [];
                    for (var i = 0; i < $scope.SelectedBuilding.Floors; i++) {
                        var temp = {
                            FloorNo: i,
                        }
                        $scope.FlatsArray.push(temp);
                    }
                    $scope.Load = false;
                })
            };

            $scope.Exit = function () {
                $scope.ViewVal = 0;
            }

            $scope.GetFloorContract = function (data) {

            }

    }]);
